export const defaultClassType = {
    classTypeName: '',
    comments: '',
}
